// Für DEV
export const STRAPI_URL = 'https://vdmk-strapi.i-taros.net/';

// Für QS
// export const STRAPI_URL = 'https://vdmk-strapi-qs.i-taros.net';

export const TEMPLATES_URL = 'https://apiqs.i-taros.net/templates/generate/';

export const TEMPLATES_SERVICE_SERVER_ID = 'dev';
export const TEMPLATES_SERVICE_CLIENT_ID = 'client_F6wto_20240409141200452';
export const TEMPLATES_SERVICE_PASSWORD = 'strifeberserkers:A*x!~HZ5]V5PkdSx';
